import {
  MESSAGE_CHANNEL,
  MESSAGE_STATUSES,
  MESSAGE_TYPES,
} from "../../../../packages/constants";
import { helpers } from "../../../../packages/helpers";
import {
  isApiMessageButtonLink,
  isApiMessageButtonCallback,
} from "../../type-guards";
import { BUTTON_TYPES } from "../../types";
import { getDateData } from "../get-date-data";
import { DICTIONARY } from "../../dictionary";
import type { ApiMessageButtons, MessageButtons, Button } from "../../types";

const MAX_BUTTONS_PER_ROW = 5;
const { getStringValue } = helpers.text;
const { getRandomUuid } = helpers.utilities;

// TODO в types
type ApiButtons = NonNullable<ApiMessageButtons["content"]["buttons"]>;
const getButtons = (buttons: ApiButtons = []): Array<Array<Button>> =>
  buttons.map((row) => {
    if (row.length > MAX_BUTTONS_PER_ROW) {
      console.warn(DICTIONARY.MESSAGE_BUTTONS.LIMIT);
    }

    return row.slice(0, MAX_BUTTONS_PER_ROW).map((button) => {
      const title = getStringValue(button?.title).trim();

      if (isApiMessageButtonLink(button)) {
        return {
          title,
          type: BUTTON_TYPES.LINK,
          url: getStringValue(button?.url),
        };
      }

      if (isApiMessageButtonCallback(button)) {
        return {
          title,
          type: BUTTON_TYPES.CALLBACK,
          callback: {
            ...button?.callback,
            scenario: getStringValue(button?.callback?.scenario),
            step: getStringValue(button?.callback?.step),
          },
        };
      }

      return {
        title: "DEFAULT_BUTTON",
        type: BUTTON_TYPES.LINK,
        url: "",
      };
    });
  });

export const getMessageButtonsData = (
  message: ApiMessageButtons,
  channel: MESSAGE_CHANNEL
): MessageButtons => ({
  id: getStringValue(message?.messageId),
  traceId:
    getStringValue(message?.traceId) ||
    getStringValue(message?.messageId) ||
    getRandomUuid("trace_id"),
  authorId: getStringValue(message?.authorId),

  date: getDateData(getStringValue(message?.datetime)),
  editDate: getDateData(getStringValue(message?.datetime)), // TODO заменить на время редактирования сообщения, когда бек реализует

  type: MESSAGE_TYPES.BUTTONS,
  status: MESSAGE_STATUSES.RECEIVED,
  channel, // необходим для корректной манипуляции скроллом в списке сообщений

  replyMessage: null,

  content: {
    text: getStringValue(message?.content?.text || message?.content?.title),
    entities: [],

    buttons: getButtons(message?.content?.buttons),
  },
});
